<template>
	<div class="pd-auto" v-if="show_body">
		<ul>
			<li>
				<h3>{{data.positionmsg.title}}</h3>
				<img v-for="(item, index) in data.positionmsg.pic" @click="previewPpt(data.positionmsg.pic.length, index)" :key="item" :src="item" alt="" />
			</li>
			<li>
				<h3>{{data.abilitymodel.title}}</h3>
				<img v-for="(item, index) in data.abilitymodel.pic" :key="item" :src="item" @click="previewPpt(data.abilitymodel.pic.length, index+data.positionmsg.pic.length)" alt="" />
			</li>
			<li>
				<h3>{{data.reflection.title}}</h3>
				<img v-for="(item, index) in data.reflection.pic" :key="item" :src="item" @click="previewPpt(data.reflection.pic.length, index+data.positionmsg.pic.length+data.abilitymodel.pic.length)" alt="" />
			</li>
		</ul>
		<div class="fixed-btn">
			<div class="auto-pd20">
				<router-link class="button" to="/totoring_mentor_wechat">我已同意</router-link>
			</div>
		</div>
	</div>
</template>
<script>
	import { ImagePreview } from 'vant'
	import { coachnotice } from '@/api/totoring'
	import { shareCon } from "@/utils/wxconfig";
	export default {
		data(){
			return {
				show_body: false,
				data: {},
				allImageList: [],
				activeIndex: 0
			}
		},
		methods: {
			pullData(){
				coachnotice()
					.then((data) => {
						this.data = data;
						this.show_body = true;
						shareCon("totoring",this);
						//
						this.allImageList = data.positionmsg.pic.concat(data.abilitymodel.pic, data.reflection.pic);

					})
			},
			previewPpt(len, index){

				ImagePreview({
				  images: this.allImageList,
				  startPosition: index,
				  onClose(){}
				});
			}
		},
		created(){
			this.pullData();
		}
	}
</script>
<style lang="scss" scoped>
	@import "@s/remChange.scss";
	.pd-auto{
		padding: 0 changeRem(0.6)+px;
    padding-top: changeRem(0.2)+px;
    width: 100%;
    img{
    	max-width: 100%;
    }
    li{
    	margin-top: changeRem(0.6)+px;
    }
    h3{
    	line-height: 60px;
    }
	}
	.fixed-btn{
		position: fixed;
		bottom: 0;
		right: 0;
		left: 0;
		bottom: 0;
		background: #f0f0f0;
		box-shadow: 0 0 0.16rem rgba(245,127,23,.2);
		.auto-pd20{
			padding: 20px 0;
		}
		.button{
			display: block;
	    margin: 0 auto;
	    text-align: center;
	    width: changeRem(11.56)+px;
	    height: changeRem(1.6)+px;
	    line-height: changeRem(1.6)+px;
	    border: none;
	    font-size: changeRem(0.68)+px;
	    color: #fff;
	    background: rgba(235, 80, 50, 1);
	    border-radius: changeRem(0.16)+px;
		}
	}
</style>